import React from 'react'
import { Link } from 'react-router-dom'
import Popup from 'reactjs-popup'
import AddNew from './AddNew'
import { deletePerson } from '../firebase'

const Nav = (props) => (
  <nav className="navbar navbar-expand-lg navbar-dark bg-primary">
    <Link to="/" className="navbar-brand">Synchronus</Link><span className="navbar-brand">Room: {props.roomcode}</span>
    <ul className="navbar-nav ml-auto">

      {props.users.map((user, key) => {
        console.log(user)
        return (<li key={key}>
          <Popup
            trigger={<button
              className="btn mr-2 text-light shadow-sm d-none d-lg-block"
              style={{ backgroundColor: user.color, borderRadius: 50 }}
            >{user.name}</button>}
            closeOnDocumentClick
          >
            <button className="btn btn-link btn-block" onClick={() => deletePerson(props.roomcode, user.name)}>Delete?</button>
          </Popup>
        </li>
        )
      })}

      <li>
        <Popup
          trigger={<button className="btn btn-success mr-2 text-light shadow-sm" style={{ borderRadius: 50 }}><i className="fas fa-plus"></i></button>}
          modal
          closeOnDocumentClick
        >
          {close => (
            <AddNew
              nameField={props.nameField}
              urlField={props.urlField}
              onNameChange={props.onNameChange}
              onUrlChange={props.onUrlChange}
              submit={props.submit}
              users={props.users}
              room={props.roomcode}
              close={close}
            />
          )}
        </Popup>
      </li>
    </ul>
  </nav>
)

export default Nav